import { Button, Grid, Stack } from "@mui/material";
import ObligationResponse from "./Response";
import { ArrowBack, PaymentOutlined } from "@mui/icons-material";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { ObligationResponsePreviewDto } from "../../../interfaces/Obligation";
import usePrint from "../../../common/hooks/usePrint";
import { CommonRoutesConfig, PublicRoutesConfig } from "../../RoutesConfig";
import PrintFooter from "../../../common/components/PrintFooter";
import obligationService from "../../../services/obligationService";

export default function Preview() {
  const { id: paramsId } = useParams();
  const obligationResponseId: number = parseInt(paramsId as string);
  const [hasPayment, setHasPayment] = useState(false);
  const navigate = useNavigate();
  const [response, setResponse] = useState<ObligationResponsePreviewDto>();

  const { printComponentRef, print } = usePrint();

  useEffect(() => {
    if (isNaN(obligationResponseId)) {
      navigate(CommonRoutesConfig.NotFound.Path, { replace: true });
    }

    (async () => {
      await obligationService.getResponseAsync(obligationResponseId).then(({ data: response }) => {
        setResponse(response);
        setHasPayment(response.obligations.some((e) => e.amount > 0));
      });
    })();
  }, []);

  const renderPrintTemplate = () => (
    <div style={{ display: "none" }}>
      <Stack spacing={3} ref={printComponentRef}>
        <ObligationResponse model={response} />
        <PrintFooter />
      </Stack>
    </div>
  );

  const renderPreview = () => (
    <Stack spacing={3}>
      <Stack direction="row" justifyContent="space-between">
        <Button startIcon={<ArrowBack />} onClick={() => navigate(-1)}>
          Назад
        </Button>

        <Button startIcon={PublicRoutesConfig.NapObligations.Print.Icon} onClick={print}>
          {PublicRoutesConfig.NapObligations.Print.Label}
        </Button>
      </Stack>

      <ObligationResponse model={response} />

      {hasPayment && (
        <Grid container marginTop={-2}>
          <Grid item xs={12} textAlign="end">
            <Button
              startIcon={<PaymentOutlined />}
              component={Link}
              to="https://portal.nra.bg/home.html#/goto:rep.nrapayment.home"
              target="_blank"
            >
              Плащане
            </Button>
          </Grid>
        </Grid>
      )}
    </Stack>
  );

  return (
    <>
      {renderPreview()}
      {renderPrintTemplate()}
    </>
  );
}
